<div class="container col-sm-12">
    <div class="row">
        <div class="menu col-sm-4" fxShow.xs="false">
            <nav class="landing-nav">
                <ul class="list-unstyled">
                    <li *ngFor="let section of dataLandingPage"><a (click)="setTitle(section.route)" href="landing#{{section.url}}">{{section.route}}</a></li>
                </ul>
            </nav>
        </div>
        <div class="content col-sm-8">
            <app-landing-content *ngFor="let section of dataLandingPage" [data]="section"></app-landing-content>
        </div>
    </div>
</div>